<template>
  <div class="history-record">
    <div class="content-wrapper">
      <el-steps
        v-if="historyData.length >= 1"
        direction="vertical"
        :active="historyData.length"
      >
        <el-step
          v-for="log in historyData"
          :key="log.id"
          :description="log.time"
          :status="getStepStatus(log)"
        >
          <template #title>
            <slot name="title" :record="log" />
          </template>
          <template #description>
            <div style="padding-bottom: 70px">
              <p class="dateTime">{{ formatDate(log.updatedAt) }}</p>
              <slot :record="log" />
            </div>
          </template>
        </el-step>
      </el-steps>

      <EmptyBlock v-else :empty-text="emptyText" />
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { formatDate } from '@/utils/date'

export default defineComponent({
  name: 'HistoryRecord',
  props: {
    historyData: { type: Array, default: () => [] },
    emptyText: { type: String, default: undefined },
    getStepStatus: { type: Function, default: () => () => 'finish' },
  },
  setup () {
    return { formatDate }
  },
})
</script>

<style lang="postcss" scoped>
.content-wrapper {
  @apply px-[20px];
}
.dateTime {
  @apply text-gray-60 text-sub pb-[8px];
}

:deep(.el-step__description) {
  @apply pr-0 top-[-4px] relative;
}

:deep(.el-step__icon.is-text) {
  @apply top-[-4px] h-[15px] w-[15px] ml-[5px];
}

:deep(.el-step__head.is-finish .el-step__icon.is-text) {
  @apply bg-primary-100;
}

:deep(.el-step__head.is-error .el-step__icon.is-text) {
  @apply bg-danger;
}

:deep(.el-step__head.is-wait .el-step__icon.is-text),
:deep(.el-step__head.is-process .el-step__icon.is-text) {
  @apply bg-gray-60;
}

:deep(.el-step__icon-inner) {
  @apply hidden;
}

:deep(.el-step__head.is-error) {
  @apply border-danger;
}

:deep(.el-step__head.is-wait),
:deep(.el-step__head.is-process) {
  @apply border-gray-60;
}

</style>
